<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey === item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'CpeInventoriesShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'cpe_inventories', tabName: 'CPE资源入库' },
        { routeName: 'cpe_inventory_statistics', tabName: '库存统计' }
      ]
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.activeKey = route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
